class SelfInviteNotificationModalCtrl {
  constructor($uibModalInstance, notification) {
    'ngInject';

    Object.assign(this, { $uibModalInstance, notification });
  }
}

export default SelfInviteNotificationModalCtrl;
